import styled from "styled-components";

const GreetingDiv = styled.div`
  .Greeting {
    width: 100%;
    text-align: left;
    word-break: keep-all;
    font-size: 1rem;
    p {
      font-size: 1rem;
      text-align: left;
      margin: 0;
      vertical-align: top;
      margin: 1em 0;
    }
  }

  @media only screen and (max-width: 480px) {
    margin: 0;
    padding-left: 1em;
    width: 90%;
  }
`;

const BusinessDiv = styled.div`
  p {
    font-size: 1rem;
    text-align: left;
    margin: 0;
    vertical-align: top;
    margin-left: 0.5em;
  }

  hr {
    margin: 0;
    width: 0.1px;
    border-left: 5px solid rgb(33, 175, 196);
    height: 1.5em;
    margin-top: 0.5em;
  }
  .BusinessContent {
    width: 100%;
    margin: 2em 0;
    font-size: 1rem;
    text-align: left;
    word-break: keep-all;
    li {
      font-size: 1rem;
      text-align: left;
    }
  }
  .BusinessHeader {
    display: flex;
    margin-bottom: 1em;
  }
  .SpecialText {
    color: rgb(23, 171, 193);
    font-size: 1.2rem;
  }
  @media only screen and (max-width: 480px) {
    margin: 0;
    padding-left: 1em;
    width: 90%;
  }
`;

const TimelineDiv = styled.div`
  border: 1px solid #efefef;
  border-radius: 15px;
  margin-bottom: 1.5em;
  ul {
    padding: 1em;
    max-height: 50vh;
    overflow-y: auto;
    margin: 0;
  }
`;

const PositionDiv = styled.div`
  .img {
    border: 1px solid gray;
    box-shadow: 2px 3px 8px 1px gray;
    border-radius: 15px;
    margin-bottom: 1em;
    z-index: 2;
    background-color: #fff;
    img {
      border-radius: 15px;
      width: 100%;
      z-index: 1;
    }
  }
`;

const IntroductionContainer = {
  GreetingDiv,
  BusinessDiv,
  TimelineDiv,
  PositionDiv
};

export default IntroductionContainer;
